import { toast } from 'react-toastify'
import moment from 'moment';

import { createAxiosInstance } from '../utils/helpers'
import { API_URL } from './index'
import * as types from './types'
import history from '../utils/history'
import { acceptedFiles } from '../utils/helpers'
import { displayMessages, getParameterByName } from './common'

export function initReducer() {
	return (dispatch) => {
		dispatch({ type: types.REINICIAR_SOLICITUD_CONTRATOANUAL })
	}
}

export function updateInputs(path, value) {
	return (dispatch) => {
		dispatch({ type: types.MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL, payload: { path, value } })
	}
}

export function createContratoAnual() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_GUARDAR_SOLICITUD_CONTRATOANUAL, payload: true })
		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_GUARDAR_SOLICITUD_CONTRATOANUAL, payload: false })
		const fn2 = (d) => d(initReducer())

		fn0(dispatch)
		const data = getState().creacioncontratoanual.toJS()

		axios.post(`${API_URL}/solicitudes/contratos-anuales`, data)
		.then(res => {

			const fn3 = () => history.push(window.FOLDER + '/solicitudes/abiertas');
			const fn4 = () => toast.success('La solicitud ha sido guardada exitosamente', { bodyClassName: 'toastify-content toastify-success' })

			fn1(dispatch);
			fn3();
			fn4();
			fn2(dispatch);

		})
		.catch(err => {
			console.log(err)
			displayMessages(dispatch, err)
			fn1(dispatch)
		})


	}
}



// WEBPACK FOOTER //
// ./src/actions/creacioncontratoanual.js